var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _polyline, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKursWoskowy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 257.7 283.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#ac893a;}.cls-3{stroke:#ac893a;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kurs_woskowy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 172.3,
    y1: 105,
    y2: 105
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 257.7,
    y1: 95.7,
    y2: 95.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 85.9,
    y2: 85.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 76.6,
    y2: 76.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 66.8,
    y2: 66.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 57.5,
    y2: 57.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 47.7,
    y2: 47.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 38.5,
    y2: 38.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 29.2,
    y2: 29.2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 19.9,
    y2: 19.9
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 63,
    y1: 10.1,
    y2: 10.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "172.3 96.1 172.3 196.4 195.6 196.4 195.6 96.1"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 85.7,
    y2: 85.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 76.4,
    y2: 76.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 66.6,
    y2: 66.6
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 57.3,
    y2: 57.3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 47.5,
    y2: 47.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 38.2,
    y2: 38.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 28.9,
    y2: 28.9
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 19.6,
    y2: 19.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.2,
    x2: 256.9,
    y1: 9.8,
    y2: 9.8
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    x2: 257.7,
    y1: 105,
    y2: 105
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    x2: 257.7,
    y1: 143.2,
    y2: 143.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    x2: 257.7,
    y1: 133.9,
    y2: 133.9
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    x2: 257.7,
    y1: 124.1,
    y2: 124.1
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 195.6,
    x2: 257.7,
    y1: 114.8,
    y2: 114.8
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 142.7v1h172.3v-1z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 133.4v1h172.3v-1z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 123.6v1h172.3v-1z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 114.3v1h172.3v-1z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 256.9,
    y1: 0.5,
    y2: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m98.607 118.67a11.61 11.61 0 0 1-11.6 11.5 11.32 11.32 0 0 1-8.3-3.4 10.94 10.94 0 0 1-3.4-8.2 11.32 11.32 0 0 1 3.4-8.3 10.94 10.94 0 0 1 8.2-3.4 11.61 11.61 0 0 1 11.7 11.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m62.947 0.6207h23.539v85.142l-23.539 26.888z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.0374
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3455 0 0 1.3455 -69.211 -183.49)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.16 266.63c-21.478-2.3e-4 -38.889 17.411-38.889 38.889 8.7e-4 21.477 17.412 38.887 38.889 38.887 21.476-8.7e-4 38.886-17.411 38.887-38.887 2.2e-4 -21.477-17.41-38.888-38.887-38.889zm8.9238 34.369c3e-3 -1.3043-1.3688-5.9111-1.3384-7.1445 0.0767-3.1042 2.0636-5.4786 3.3158-4.5792 4.1579 3.8468 1.5958 6.7205 3.0032 9.9967 1.606 1.8436 4.6795-0.17991 5.37-1.7896 1.12 0.44043 1.3253 6.2294 1.3252 8.0363-3.4e-4 11.377-9.2229 20.599-20.6 20.6-11.377 7.2e-4 -20.601-9.2222-20.602-20.6-3.4e-4 -5.257 0.91748-10.159 4.1581-13.799 1.0181-1.1436 3.0059-3.39 4.6561-4.5224 1.1223-0.77012 2.683-1.0249 2.487-0.0669-1.1062 5.4089 6.6772 4.6671 7.2817 0.33071 0.12548-0.90025 2.0648 0.81486 2.7026 1.7077 0.7327 1.0256 1.3605 2.8271 1.5913 4.8044 0.12737 1.0901-0.59913 6.1577-0.47796 7.3503 0.83203 4.7799 7.0711 4.3108 7.1264-0.32429z",
    color: "#000000",
    fill: "#ac893a",
    strokeWidth: 0.55937,
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.16 266.35c-21.629-2.3e-4 -39.169 17.539-39.168 39.168 8.8e-4 21.628 17.54 39.169 39.168 39.168 21.627-8.7e-4 39.16-17.541 39.161-39.168 2.3e-4 -21.628-17.533-39.167-39.161-39.168zm0 0.56099c21.326 8.7e-4 38.608 17.282 38.607 38.607-8.7e-4 21.325-17.282 38.606-38.607 38.607-21.326 2.2e-4 -38.614-17.281-38.615-38.607-2.3e-4 -21.327 17.288-38.608 38.615-38.607z",
    color: "#000000",
    strokeWidth: 3.7795,
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers fill stroke"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKursWoskowy);
export default __webpack_public_path__ + "static/media/kurs_woskowy.eab87917aa4ead39976ef7bca0fe3b84.svg";
export { ForwardRef as ReactComponent };